import { useEffect, useRef } from 'react';
import { usePrivacyPrefs } from '../contexts/PrivacyPrefsContext';
import { resolveBrowserDisguise } from '../constants/privacyPresets';

const DEFAULT_TITLE = 'MyInvestFolio - Portfolio Infrastructure for Investors';

/**
 * BrowserDisguiseApplier — invisible mount-once component that sets the
 * browser tab title and favicon based on the member's chosen disguise.
 *
 * Runs only for signed-in members (renders nothing).
 */
const BrowserDisguiseApplier = () => {
  const { prefs } = usePrivacyPrefs();
  const originalFaviconRef = useRef(null);

  useEffect(() => {
    // Remember the original bundled MIF favicon on first render so we
    // can restore it when the member picks the default disguise back.
    if (originalFaviconRef.current === null) {
      const link = document.querySelector("link[rel~='icon']");
      originalFaviconRef.current = link ? link.href : '';
    }

    const preset = resolveBrowserDisguise(prefs);
    document.title = preset.key === 'myinvestfolio' ? DEFAULT_TITLE : preset.tabTitle;

    let link = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }
    if (preset.favicon) {
      link.type = 'image/svg+xml';
      link.href = preset.favicon;
    } else if (originalFaviconRef.current) {
      // Default preset — restore the bundled MIF favicon.
      link.type = 'image/x-icon';
      link.href = originalFaviconRef.current;
    }
  }, [prefs.browser_disguise, prefs.browser_disguise_custom]);

  return null;
};

export default BrowserDisguiseApplier;
